/**
 * @flow
 * @relayHash 1e2f305134460c2eb7840618648f1526
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type mobileNavWrapperRootQueryResponse = {|
  +viewer: ?{| |};
|};
*/


/*
query mobileNavWrapperRootQuery(
  $hasUserId: Boolean!
  $showMarketingMessages: Boolean!
  $fetchMarketingMessagesTransactions: Boolean = false
  $userId: String!
  $userIds: [String!]
) {
  viewer {
    ...MobileNavWrapper_viewer
    id
  }
}

fragment MobileNavWrapper_viewer on Viewer {
  ...MobileNav_viewer
  allTransactions: transactions(buyerId: $userIds, first: 0) @include(if: $hasUserId) {
    totalResults
  }
  initiatedTransactions: transactions(buyerId: $userIds, viewName: "buyerTracking.initiated", first: 0) @include(if: $hasUserId) {
    totalResults
  }
  submittedTransactions: transactions(buyerId: $userIds, viewName: "buyerTracking.submitted", first: 0) @include(if: $hasUserId) {
    totalResults
  }
  confirmedTransactionsMostRecent: transactions(buyerId: $userIds, sort: "createdDate asc", viewName: "buyerTracking.confirmed", first: 1) @include(if: $hasUserId) {
    totalResults
    edges {
      node {
        mostRecentOffer {
          createdDate
          subTotalAmount {
            convertedAmounts {
              USD
            }
          }
          id
        }
        id
      }
    }
  }
  user(userId: $userId) @include(if: $hasUserId) {
    isVerifiedTrade
    firstSessionDate
    isTrade: hasPermission(name: "B_TRADE_CHECKOUT")
    hasVipPermission: hasPermission(name: "B_VIP_CHECKOUT")
    profile {
      email
      zipCode
      currency
    }
    serviceId
    totalMessagesToDealers
    tradeFirm {
      serviceId
      tier
      id
    }
    verifiedTradeStatus
    isPromoCodeEligible(code: "SAVE15")
    ...MobileNav_user
    id
  }
}

fragment MobileNav_viewer on Viewer {
  ...MobileNavMenu_viewer
  ... on Viewer @include(if: $showMarketingMessages) {
    ...MessageBanner_viewer
  }
}

fragment MobileNav_user on User {
  ...MobileNavMenu_user
  ...MobileNavHeader_user
  ... on User @include(if: $showMarketingMessages) {
    ...MessageBanner_user
  }
}

fragment MobileNavMenu_user on User {
  conversationSummary {
    totalUnreadConversationCount
  }
  ...MobileNavMenuBody_user
}

fragment MobileNavHeader_user on User {
  isVerifiedTrade
  conversationSummary {
    totalUnreadConversationCount
  }
  ...MobileNavCartContainer_user
}

fragment MessageBanner_user on User {
  isVip
  isVerifiedTrade
  verifiedTradeStatus
  verifiedTradeSubStatus
  tradeFirm {
    loyalty {
      status
    }
    id
  }
}

fragment MobileNavCartContainer_user on User {
  cart {
    items {
      item {
        itemId
      }
      id
    }
    id
  }
}

fragment MobileNavMenuBody_user on User {
  ...MobileNavAuthButtons_user
}

fragment MobileNavAuthButtons_user on User {
  serviceId
}

fragment MobileNavMenu_viewer on Viewer {
  navigation {
    modules {
      name
      isVertical
      url
      items {
        visible
        type
        name
        items {
          name
          url
          id
        }
        id
      }
      categories {
        name
        count
        label
        id
      }
      id
    }
    id
  }
}

fragment MessageBanner_viewer on Viewer {
  allTransactions: transactions(buyerId: $userIds, first: 0) @include(if: $fetchMarketingMessagesTransactions) {
    totalResults
  }
  initiatedTransactions: transactions(buyerId: $userIds, viewName: "buyerTracking.initiated", first: 0) @include(if: $fetchMarketingMessagesTransactions) {
    totalResults
  }
  submittedTransactions: transactions(buyerId: $userIds, viewName: "buyerTracking.submitted", first: 0) @include(if: $fetchMarketingMessagesTransactions) {
    totalResults
  }
  confirmedTransactions: transactions(buyerId: $userIds, sort: "createdDate asc", viewName: "buyerTracking.confirmed", first: 0) @include(if: $fetchMarketingMessagesTransactions) {
    totalResults
  }
}
*/

const batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "hasUserId",
        "type": "Boolean!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "showMarketingMessages",
        "type": "Boolean!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "fetchMarketingMessagesTransactions",
        "type": "Boolean",
        "defaultValue": false
      },
      {
        "kind": "LocalArgument",
        "name": "userId",
        "type": "String!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "userIds",
        "type": "[String!]",
        "defaultValue": null
      }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "mobileNavWrapperRootQuery",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "MobileNavWrapper_viewer",
            "args": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "mobileNavWrapperRootQuery",
  "query": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "hasUserId",
        "type": "Boolean!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "showMarketingMessages",
        "type": "Boolean!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "fetchMarketingMessagesTransactions",
        "type": "Boolean",
        "defaultValue": false
      },
      {
        "kind": "LocalArgument",
        "name": "userId",
        "type": "String!",
        "defaultValue": null
      },
      {
        "kind": "LocalArgument",
        "name": "userIds",
        "type": "[String!]",
        "defaultValue": null
      }
    ],
    "kind": "Root",
    "name": "mobileNavWrapperRootQuery",
    "operation": "query",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Navigation",
            "name": "navigation",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "NavigationModule",
                "name": "modules",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "isVertical",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "url",
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "NavigationTopLevel",
                    "name": "items",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "visible",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "type",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "name",
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "args": null,
                        "concreteType": "NavigationItem",
                        "name": "items",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "name",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "url",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "id",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "id",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "NavigationModuleCategories",
                    "name": "categories",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "name",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "count",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "label",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "id",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "id",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "hasUserId",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": "allTransactions",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "buyerId",
                    "variableName": "userIds",
                    "type": "[String]"
                  },
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 0,
                    "type": "Int"
                  }
                ],
                "concreteType": "TransactionConnection",
                "name": "transactions",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "totalResults",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": "initiatedTransactions",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "buyerId",
                    "variableName": "userIds",
                    "type": "[String]"
                  },
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 0,
                    "type": "Int"
                  },
                  {
                    "kind": "Literal",
                    "name": "viewName",
                    "value": "buyerTracking.initiated",
                    "type": "String"
                  }
                ],
                "concreteType": "TransactionConnection",
                "name": "transactions",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "totalResults",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": "submittedTransactions",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "buyerId",
                    "variableName": "userIds",
                    "type": "[String]"
                  },
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 0,
                    "type": "Int"
                  },
                  {
                    "kind": "Literal",
                    "name": "viewName",
                    "value": "buyerTracking.submitted",
                    "type": "String"
                  }
                ],
                "concreteType": "TransactionConnection",
                "name": "transactions",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "totalResults",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": "confirmedTransactionsMostRecent",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "buyerId",
                    "variableName": "userIds",
                    "type": "[String]"
                  },
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1,
                    "type": "Int"
                  },
                  {
                    "kind": "Literal",
                    "name": "sort",
                    "value": "createdDate asc",
                    "type": "String"
                  },
                  {
                    "kind": "Literal",
                    "name": "viewName",
                    "value": "buyerTracking.confirmed",
                    "type": "String"
                  }
                ],
                "concreteType": "TransactionConnection",
                "name": "transactions",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "totalResults",
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "TransactionEdge",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "args": null,
                        "concreteType": "Transaction",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "args": null,
                            "concreteType": "Offer",
                            "name": "mostRecentOffer",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "args": null,
                                "name": "createdDate",
                                "storageKey": null
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "args": null,
                                "concreteType": "FinancialAmount",
                                "name": "subTotalAmount",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ConvertedAmounts",
                                    "name": "convertedAmounts",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "args": null,
                                        "name": "USD",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "args": null,
                                "name": "id",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "id",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "userId",
                    "variableName": "userId",
                    "type": "String!"
                  }
                ],
                "concreteType": "User",
                "name": "user",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "TradeFirmType",
                    "name": "tradeFirm",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "serviceId",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "tier",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "id",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "isVerifiedTrade",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": "isTrade",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "name",
                        "value": "B_TRADE_CHECKOUT",
                        "type": "String!"
                      }
                    ],
                    "name": "hasPermission",
                    "storageKey": "hasPermission{\"name\":\"B_TRADE_CHECKOUT\"}"
                  },
                  {
                    "kind": "ScalarField",
                    "alias": "hasVipPermission",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "name",
                        "value": "B_VIP_CHECKOUT",
                        "type": "String!"
                      }
                    ],
                    "name": "hasPermission",
                    "storageKey": "hasPermission{\"name\":\"B_VIP_CHECKOUT\"}"
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "Profile",
                    "name": "profile",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "email",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "zipCode",
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "currency",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "serviceId",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "totalMessagesToDealers",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "firstSessionDate",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "verifiedTradeStatus",
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "code",
                        "value": "SAVE15",
                        "type": "String!"
                      }
                    ],
                    "name": "isPromoCodeEligible",
                    "storageKey": "isPromoCodeEligible{\"code\":\"SAVE15\"}"
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "Summary",
                    "name": "conversationSummary",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "totalUnreadConversationCount",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "args": null,
                    "concreteType": "PortfolioV1",
                    "name": "cart",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "args": null,
                        "concreteType": "PortfolioItemV1",
                        "name": "items",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "args": null,
                            "concreteType": "ItemSummary",
                            "name": "item",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "args": null,
                                "name": "itemId",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "id",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "args": null,
                        "name": "id",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "kind": "Condition",
                    "passingValue": true,
                    "condition": "showMarketingMessages",
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "type": "User",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "isVip",
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "verifiedTradeSubStatus",
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "args": null,
                            "concreteType": "TradeFirmType",
                            "name": "tradeFirm",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "args": null,
                                "concreteType": "TradeFirmLoyaltyType",
                                "name": "loyalty",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "args": null,
                                    "name": "status",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ]
                      }
                    ]
                  }
                ],
                "storageKey": null
              }
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "showMarketingMessages",
            "selections": [
              {
                "kind": "InlineFragment",
                "type": "Viewer",
                "selections": [
                  {
                    "kind": "Condition",
                    "passingValue": true,
                    "condition": "fetchMarketingMessagesTransactions",
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": "allTransactions",
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "buyerId",
                            "variableName": "userIds",
                            "type": "[String]"
                          },
                          {
                            "kind": "Literal",
                            "name": "first",
                            "value": 0,
                            "type": "Int"
                          }
                        ],
                        "concreteType": "TransactionConnection",
                        "name": "transactions",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "totalResults",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": "initiatedTransactions",
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "buyerId",
                            "variableName": "userIds",
                            "type": "[String]"
                          },
                          {
                            "kind": "Literal",
                            "name": "first",
                            "value": 0,
                            "type": "Int"
                          },
                          {
                            "kind": "Literal",
                            "name": "viewName",
                            "value": "buyerTracking.initiated",
                            "type": "String"
                          }
                        ],
                        "concreteType": "TransactionConnection",
                        "name": "transactions",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "totalResults",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": "submittedTransactions",
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "buyerId",
                            "variableName": "userIds",
                            "type": "[String]"
                          },
                          {
                            "kind": "Literal",
                            "name": "first",
                            "value": 0,
                            "type": "Int"
                          },
                          {
                            "kind": "Literal",
                            "name": "viewName",
                            "value": "buyerTracking.submitted",
                            "type": "String"
                          }
                        ],
                        "concreteType": "TransactionConnection",
                        "name": "transactions",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "totalResults",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": "confirmedTransactions",
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "buyerId",
                            "variableName": "userIds",
                            "type": "[String]"
                          },
                          {
                            "kind": "Literal",
                            "name": "first",
                            "value": 0,
                            "type": "Int"
                          },
                          {
                            "kind": "Literal",
                            "name": "sort",
                            "value": "createdDate asc",
                            "type": "String"
                          },
                          {
                            "kind": "Literal",
                            "name": "viewName",
                            "value": "buyerTracking.confirmed",
                            "type": "String"
                          }
                        ],
                        "concreteType": "TransactionConnection",
                        "name": "transactions",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "args": null,
                            "name": "totalResults",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "text": "query mobileNavWrapperRootQuery(\n  $hasUserId: Boolean!\n  $showMarketingMessages: Boolean!\n  $fetchMarketingMessagesTransactions: Boolean = false\n  $userId: String!\n  $userIds: [String!]\n) {\n  viewer {\n    ...MobileNavWrapper_viewer\n    id\n  }\n}\n\nfragment MobileNavWrapper_viewer on Viewer {\n  ...MobileNav_viewer\n  allTransactions: transactions(buyerId: $userIds, first: 0) @include(if: $hasUserId) {\n    totalResults\n  }\n  initiatedTransactions: transactions(buyerId: $userIds, viewName: \"buyerTracking.initiated\", first: 0) @include(if: $hasUserId) {\n    totalResults\n  }\n  submittedTransactions: transactions(buyerId: $userIds, viewName: \"buyerTracking.submitted\", first: 0) @include(if: $hasUserId) {\n    totalResults\n  }\n  confirmedTransactionsMostRecent: transactions(buyerId: $userIds, sort: \"createdDate asc\", viewName: \"buyerTracking.confirmed\", first: 1) @include(if: $hasUserId) {\n    totalResults\n    edges {\n      node {\n        mostRecentOffer {\n          createdDate\n          subTotalAmount {\n            convertedAmounts {\n              USD\n            }\n          }\n          id\n        }\n        id\n      }\n    }\n  }\n  user(userId: $userId) @include(if: $hasUserId) {\n    isVerifiedTrade\n    firstSessionDate\n    isTrade: hasPermission(name: \"B_TRADE_CHECKOUT\")\n    hasVipPermission: hasPermission(name: \"B_VIP_CHECKOUT\")\n    profile {\n      email\n      zipCode\n      currency\n    }\n    serviceId\n    totalMessagesToDealers\n    tradeFirm {\n      serviceId\n      tier\n      id\n    }\n    verifiedTradeStatus\n    isPromoCodeEligible(code: \"SAVE15\")\n    ...MobileNav_user\n    id\n  }\n}\n\nfragment MobileNav_viewer on Viewer {\n  ...MobileNavMenu_viewer\n  ... on Viewer @include(if: $showMarketingMessages) {\n    ...MessageBanner_viewer\n  }\n}\n\nfragment MobileNav_user on User {\n  ...MobileNavMenu_user\n  ...MobileNavHeader_user\n  ... on User @include(if: $showMarketingMessages) {\n    ...MessageBanner_user\n  }\n}\n\nfragment MobileNavMenu_user on User {\n  conversationSummary {\n    totalUnreadConversationCount\n  }\n  ...MobileNavMenuBody_user\n}\n\nfragment MobileNavHeader_user on User {\n  isVerifiedTrade\n  conversationSummary {\n    totalUnreadConversationCount\n  }\n  ...MobileNavCartContainer_user\n}\n\nfragment MessageBanner_user on User {\n  isVip\n  isVerifiedTrade\n  verifiedTradeStatus\n  verifiedTradeSubStatus\n  tradeFirm {\n    loyalty {\n      status\n    }\n    id\n  }\n}\n\nfragment MobileNavCartContainer_user on User {\n  cart {\n    items {\n      item {\n        itemId\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment MobileNavMenuBody_user on User {\n  ...MobileNavAuthButtons_user\n}\n\nfragment MobileNavAuthButtons_user on User {\n  serviceId\n}\n\nfragment MobileNavMenu_viewer on Viewer {\n  navigation {\n    modules {\n      name\n      isVertical\n      url\n      items {\n        visible\n        type\n        name\n        items {\n          name\n          url\n          id\n        }\n        id\n      }\n      categories {\n        name\n        count\n        label\n        id\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment MessageBanner_viewer on Viewer {\n  allTransactions: transactions(buyerId: $userIds, first: 0) @include(if: $fetchMarketingMessagesTransactions) {\n    totalResults\n  }\n  initiatedTransactions: transactions(buyerId: $userIds, viewName: \"buyerTracking.initiated\", first: 0) @include(if: $fetchMarketingMessagesTransactions) {\n    totalResults\n  }\n  submittedTransactions: transactions(buyerId: $userIds, viewName: \"buyerTracking.submitted\", first: 0) @include(if: $fetchMarketingMessagesTransactions) {\n    totalResults\n  }\n  confirmedTransactions: transactions(buyerId: $userIds, sort: \"createdDate asc\", viewName: \"buyerTracking.confirmed\", first: 0) @include(if: $fetchMarketingMessagesTransactions) {\n    totalResults\n  }\n}\n"
};

module.exports = batch;



// WEBPACK FOOTER //
// ./src/queries/__generated__/mobileNavWrapperRootQuery.graphql.js